import React, { Component } from 'react';
import { Input, Modal } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import {
  getUseNotifyPosOrderRelationApp,
  setUseNotifyPosOrderRelationApp,
  getPosOrderRelationAppAllowDuplicates,
  setPosOrderRelationAppAllowDuplicates,
  getNotifyPosOrderRelationAppPort,
  setNotifyPosOrderRelationAppPort,
} from '../../lib/module';
import ClickSwitch from '../input/ClickSwitch';
import '../../css/modal.scss';
import Const from '../../const';
import string from '../../res/string';
import image from '../../res/image';
import {modalStyle} from "../../lib/util/codeUtil";

class PosOrderRelaionAppModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      notifyPosOrderRelationApp: Const.posOrderRelationAppEnable,
      posOrderRelationAppPort: Const.posOrderRelationAppPort,
      posOrderRelationAppAllowDuplicates: Const.posOrderRelationAppEnable,
    };
    this.formRef = React.createRef();
  }

  componentDidMount() {
    this.setState({
      notifyPosOrderRelationApp: getUseNotifyPosOrderRelationApp(),
      posOrderRelationAppPort: getNotifyPosOrderRelationAppPort(),
      posOrderRelationAppAllowDuplicates:
        getPosOrderRelationAppAllowDuplicates(),
    });
  }

  onChangePosOrderRelationAppPort = () => {
    const self = this;
    Modal.confirm({
      ...modalStyle,
      content: 'POS연동 포트를 변경 하시겠습니까?',
      okText: '확인',
      cancelText: '취소',
      onOk() {
        setNotifyPosOrderRelationAppPort(self.state.posOrderRelationAppPort);
      },
      onCancel() {},
    });
  };

  render() {
    const { isOpen, close } = this.props;
    const skinType = Const.skinType.toUpperCase();
    return (
      <React.Fragment>
        {isOpen ? (
          <React.Fragment>
            <div className="Modal-overlay" onClick={close} />
            <div className="Modal">
              <div className="guide-title"> {string.name} POS 연동</div>
              <div className="guide-image" onClick={close}>
                <img style={{ display: 'inline' }} src={image.closeIcon} alt="" />
              </div>
              <div
                className="guide-content"
                style={{
                  paddingBottom: '40px',
                  display: 'flex',
                  justifyContent: 'space-around',
                  verticalAlign: 'middle',
                }}>
                <div className="pos-element-block-content-text4" style={{}}>
                  {' '}
                  SUB POS 연동
                  <ClickSwitch
                    flag={this.state.notifyPosOrderRelationApp}
                    onChange={(flag) => {
                      this.setState({ notifyPosOrderRelationApp: flag });
                      setUseNotifyPosOrderRelationApp(flag);
                    }}
                  />
                </div>
                <div
                  className="pos-element-block-content-text4"
                  style={{ marginTop: '2px' }}>
                  <div
                    className="pos-element-block-content-text4"
                    style={{ marginRight: '5px' }}>
                    Port 번호
                  </div>
                  <div className="pos-element-block-content-field-port">
                    <Input
                      type="number"
                      value={this.state.posOrderRelationAppPort}
                      onFocus={() => {}}
                      autoComplete="off"
                      placeholder="Port"
                      style={{ borderRadius: '7px', fontSize: '11px' }}
                      maxLength={6}
                      onChange={(e) => {
                        this.setState({
                          posOrderRelationAppPort: e.target.value,
                        });
                      }}
                    />
                  </div>
                  <div
                    className={skinType === "GOGOIT" ? "gogoit-pos-element-block5-content-btn2" : "pos-element-block5-content-btn2"}
                    onClick={() => {
                      this.onChangePosOrderRelationAppPort();
                    }}
                    style={{ padding: '8px', verticalAlign: 'middle' }}>
                    변경
                  </div>
                </div>

                <div className="pos-element-block-content-text4">
                  중복 허용
                  <ClickSwitch
                    flag={this.state.posOrderRelationAppAllowDuplicates}
                    onChange={(flag) => {
                      this.setState({
                        posOrderRelationAppAllowDuplicates: flag,
                      });
                      setPosOrderRelationAppAllowDuplicates(flag);
                    }}
                  />
                </div>
              </div>
            </div>
          </React.Fragment>
        ) : null}
      </React.Fragment>
    );
  }
}

export default PosOrderRelaionAppModal;
